/**
 * DH FAB — Site-mode marketing card only.
 *
 * Shows a floating "Build Your Pack" card on pages that don't already have
 * a sticky ATC (PDPs). Minimizable to a small circular icon; dismissal
 * persists for the session via sessionStorage.
 *
 * Builder-page stepper chrome is a separate component (<dh-builder-footer>).
 */

if (!customElements.get('dh-fab')) {
  class DHFAB extends HTMLElement {
    connectedCallback() {
      const siteMode = this.querySelector('[data-mode="site"]');
      const miniMode = this.querySelector('[data-mode="mini"]');

      // Don't double up with an existing PDP sticky ATC
      if (document.querySelector('.product-form__submit, [data-product-form]')) {
        this.classList.add('is-dismissed');
        return;
      }

      // Restore prior session minimization state
      const minimized = sessionStorage.getItem('dh-fab-dismissed');
      if (minimized) {
        if (siteMode) siteMode.hidden = true;
        if (miniMode) miniMode.hidden = false;
      } else {
        if (siteMode) siteMode.hidden = false;
        if (miniMode) miniMode.hidden = true;
      }

      // Minimize to icon
      const dismissBtn = this.querySelector('[data-action="dismiss"]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (siteMode) siteMode.hidden = true;
          if (miniMode) miniMode.hidden = false;
          sessionStorage.setItem('dh-fab-dismissed', '1');
        });
      }

      // Restore from icon
      if (miniMode) {
        miniMode.addEventListener('click', () => {
          miniMode.hidden = true;
          if (siteMode) siteMode.hidden = false;
          sessionStorage.removeItem('dh-fab-dismissed');
        });
      }
    }
  }

  customElements.define('dh-fab', DHFAB);
}
